import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import styles from '../../style/DefaultPage.module.css';
import 'react-toastify/dist/ReactToastify.css';
import AddTariffsModal from './AddTariffsModal';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import { toast } from 'react-toastify';
import TableFilter from '../../components/TableFilter';
import { FaPlus, FaTimes } from 'react-icons/fa';

const CustomerTariffsPage = () => {
  const [showTariffModal, setShowTariffModal] = useState(false);
  const [tariffs, setTariffs] = useState([]);
  const [filteredTariffs, setFilteredTariffs] = useState([]);
  const [filters, setFilters] = useState({});

  const handleFilter = (column, value) => {
    const newFilters = { ...filters, [column]: value };
    setFilters(newFilters);

    let filtered = tariffs;
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) {
        filtered = filtered.filter(tariff =>
          String(tariff[key])
            .toLowerCase()
            .includes(newFilters[key].toLowerCase())
        );
      }
    });

    setFilteredTariffs(filtered);
  };

  useEffect(() => {
    setFilteredTariffs(tariffs);
  }, [tariffs]);

  const fetchTariffs = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'Tariffs'));
      const tariffsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setTariffs(tariffsData);
    } catch (error) {
      console.error('Error fetching tariffs:', error);
      toast.error('Tarifeler yüklenirken bir hata oluştu');
    }
  };

  useEffect(() => {
    fetchTariffs();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return format(new Date(dateString), 'dd MMMM yyyy', { locale: tr });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Tarife Yönetimi</h1>
        <div className={styles.buttonGroup}>
          {Object.keys(filters).length > 0 && (
            <button
              className={styles.dangerButton}
              onClick={() => {
                setFilters({});
                setFilteredTariffs(tariffs);
              }}
            >
              <FaTimes style={{ marginRight: '0.5rem' }} /> Tüm Filtreleri Temizle
            </button>
          )}
          <button
            className={styles.addButton}
            onClick={() => setShowTariffModal(true)}
          >
            <FaPlus style={{ marginRight: '0.5rem' }} /> Yeni Tarife Ekle
          </button>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>
                  Tarife Tipi
                  <TableFilter column="type" type="text" onFilter={handleFilter} />
                </th>
                <th>
                  Tarife Değer
                  <TableFilter column="value" type="text" onFilter={handleFilter} />
                </th>
                <th>
                  Fiyat
                  <TableFilter column="price" type="text" onFilter={handleFilter} />
                </th>
                <th>
                  Döviz Tipi
                  <TableFilter
                    column="currency"
                    type="select"
                    options={[
                      { value: "", label: "Tümü" },
                      { value: "TRY", label: "TRY" },
                      { value: "USD", label: "USD" },
                      { value: "EUR", label: "EUR" }
                    ]}
                    onFilter={handleFilter}
                  />
                </th>
                <th>
                  Tarih
                  <TableFilter column="date" type="date" onFilter={handleFilter} />
                </th>
                <th>
                  Subcontractor
                  <TableFilter
                    column="isSubcontractor"
                    type="select"
                    options={[
                      { value: "", label: "Tümü" },
                      { value: "Evet", label: "Evet" },
                      { value: "Hayır", label: "Hayır" }
                    ]}
                    onFilter={handleFilter}
                  />
                </th>
                <th>
                  Bilgi
                  <TableFilter column="info" type="text" onFilter={handleFilter} />
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredTariffs.map((tariff) => (
                <tr key={tariff.id}>
                  <td>{tariff.type}</td>
                  <td>{tariff.value}</td>
                  <td>{tariff.price}</td>
                  <td>{tariff.currency}</td>
                  <td>{formatDate(tariff.date)}</td>
                  <td>{tariff.isSubcontractor}</td>
                  <td>{tariff.info}</td>
                </tr>
              ))}
              {filteredTariffs.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center' }}>
                    Henüz tarife kaydı bulunmamaktadır.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <AddTariffsModal
        show={showTariffModal}
        handleClose={() => {
          setShowTariffModal(false);
          fetchTariffs();
        }}
      />

    </div>
  );
};

export default CustomerTariffsPage;